import { TApplicationState } from '../../types/redux';

export function getJKid(state: TApplicationState) {
  const {
    newbuilding: { id },
  } = state;

  return id;
}
